import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import ArrowBack from '@vtex/styleguide/lib/icon/ArrowBack'
import noop from 'lodash/noop'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'

const BackHeader = ({ onClick, messageId, intl }) => {
  return (
    <div className="c-action-primary t-heading-3 mb2">
      <div
        data-testid="fulfillment-details-go-back"
        className="pointer di"
        onClick={onClick}
      >
        <ArrowBack />
        <span className="f5 pl3 b">
          {intl.formatMessage({ id: messageId })}
        </span>
      </div>
    </div>
  )
}

BackHeader.defaultProps = {
  messageId: 'giveUpErrorBtnText',
  onClick: noop,
}

BackHeader.propTypes = {
  intl: intlShape.isRequired,
  onClick: PropTypes.func.isRequired,
  messageId: PropTypes.string.isRequired,
  router: PropTypes.any,
}

export default injectIntl(BackHeader)
